import { cx, styled } from "simplydo/react/styled";

import type { CardContentProps } from "./Card.types";

const Content = styled.div<{ $textAlign?: string }>`
  flex-grow: 1;
  border: none;
  border-top: none;
  background: none;
  margin: 0;
  padding: 1em;
  box-shadow: none;
  font-size: 1em;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.87);
  text-align: ${({ $textAlign }) => $textAlign || "left"};

  &.is-extra {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.4);

    border-radius: 0 0 0.3rem 0.3rem;
  }
`;

const CardContentComponent = (props: CardContentProps) => {
  const { extra, textAlign, children, className, style } = props;
  return (
    <Content
      className={cx(extra && "is-extra", className)}
      style={style}
      $textAlign={textAlign}
    >
      {children}
    </Content>
  );
};

export const CardContent = styled(CardContentComponent)``;
